import React, { Component } from 'react';

class SocialShare extends Component {
    render() {
        return (
            <div className="social-share is-row">
                <div className="social-share-title gapr-10">แบ่งปัน:</div>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${this.props.shareURL}`} target="_blank" className="gapr-8"><img src="/resources/images/ic-facebook-color.svg" alt="facebook"/></a>
                <a href={`https://twitter.com/home?status= ${this.props.title} ${this.props.shareURL}`} target="_blank" className="gapr-8"><img src="/resources/images/ic-twitter-color.svg" alt="twitter"/></a>
                <a href={`https://plus.google.com/share?url=${this.props.shareURL}`} target="_blank"><img src="/resources/images/ic-google-color.svg" alt="google"/></a>
            </div>
        );
    }
}

export default SocialShare;
